import React, { useEffect, useState } from 'react'
import toast from 'react-hot-toast'
import { RedImmobile, RedRendicontazione } from '../../../types/red'
import { TIPI_RENDICONTAZIONE_LABEL, STATO_RENDICONTAZIONE_CONFIG, EUR } from '../../../constants/red'
import { redApi } from '../../../services/api'

const TabRendicontazioni: React.FC<{ immobile: RedImmobile; onUpdate: () => void }> = ({ immobile, onUpdate }) => {
  const [rendicontazioni, setRendicontazioni] = useState<RedRendicontazione[]>([])
  const [loading, setLoading] = useState(true)
  const [showForm, setShowForm] = useState(false)
  const [form, setForm] = useState({ tipo: 'semestrale', periodo_inizio: '', periodo_fine: '', importo_rendicontato: '', codice_cup: '', codice_cig: '', protocollo_usr: '', note: '' })

  const load = () => {
    redApi.rendicontazioni.listByImmobile(immobile.id).then(res => {
      setRendicontazioni(res.data)
      setLoading(false)
    })
  }

  useEffect(load, [immobile.id])

  const handleCreate = async () => {
    if (!form.periodo_inizio || !form.periodo_fine) { toast.error('Periodo obbligatorio'); return }
    try {
      await redApi.rendicontazioni.create({
        immobile_id: immobile.id,
        tipo: form.tipo,
        periodo_inizio: form.periodo_inizio,
        periodo_fine: form.periodo_fine,
        importo_rendicontato: form.importo_rendicontato ? parseFloat(form.importo_rendicontato) : null,
        codice_cup: form.codice_cup || null,
        codice_cig: form.codice_cig || null,
        protocollo_usr: form.protocollo_usr || null,
        note: form.note || null,
      })
      toast.success('Rendicontazione aggiunta')
      setForm({ tipo: 'semestrale', periodo_inizio: '', periodo_fine: '', importo_rendicontato: '', codice_cup: '', codice_cig: '', protocollo_usr: '', note: '' })
      setShowForm(false)
      load()
      onUpdate()
    } catch { toast.error('Errore creazione') }
  }

  if (loading) return <div className="text-gray-400">Caricamento...</div>

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-gray-800">Rendicontazioni USR/ANAC</h2>
        <button onClick={() => setShowForm(v => !v)} className="btn-primary text-sm">+ Aggiungi</button>
      </div>

      {showForm && (
        <div className="card p-4 mb-4 grid grid-cols-3 gap-3">
          <div><label className="label">Tipo</label>
            <select className="select" value={form.tipo} onChange={e => setForm({...form, tipo: e.target.value})}>
              {Object.entries(TIPI_RENDICONTAZIONE_LABEL).map(([k,v]) => <option key={k} value={k}>{v}</option>)}
            </select>
          </div>
          <div><label className="label">Periodo inizio</label><input type="date" className="input" value={form.periodo_inizio} onChange={e => setForm({...form, periodo_inizio: e.target.value})} /></div>
          <div><label className="label">Periodo fine</label><input type="date" className="input" value={form.periodo_fine} onChange={e => setForm({...form, periodo_fine: e.target.value})} /></div>
          <div><label className="label">Importo (€)</label><input type="number" className="input" value={form.importo_rendicontato} onChange={e => setForm({...form, importo_rendicontato: e.target.value})} /></div>
          <div><label className="label">CUP</label><input className="input" value={form.codice_cup} onChange={e => setForm({...form, codice_cup: e.target.value})} /></div>
          <div><label className="label">CIG</label><input className="input" value={form.codice_cig} onChange={e => setForm({...form, codice_cig: e.target.value})} /></div>
          <div><label className="label">Protocollo USR</label><input className="input" value={form.protocollo_usr} onChange={e => setForm({...form, protocollo_usr: e.target.value})} /></div>
          <div className="col-span-2"><label className="label">Note</label><input className="input" value={form.note} onChange={e => setForm({...form, note: e.target.value})} /></div>
          <div className="col-span-3"><button onClick={handleCreate} className="btn-primary text-sm">Salva</button></div>
        </div>
      )}

      <div className="space-y-2">
        {rendicontazioni.map(r => {
          const cfg = STATO_RENDICONTAZIONE_CONFIG[r.stato]
          return (
            <div key={r.id} className="flex items-center justify-between bg-white border border-gray-200 rounded-lg p-3">
              <div>
                <div className="text-sm font-medium text-gray-800">{TIPI_RENDICONTAZIONE_LABEL[r.tipo] || r.tipo} {r.protocollo_usr && `· ${r.protocollo_usr}`}</div>
                <div className="text-xs text-gray-400">
                  Periodo: {new Date(r.periodo_inizio).toLocaleDateString('it-IT')} — {new Date(r.periodo_fine).toLocaleDateString('it-IT')}
                  {r.importo_rendicontato != null && ` · Importo: ${EUR.format(r.importo_rendicontato)}`}
                  {r.codice_cup && ` · CUP: ${r.codice_cup}`}
                  {r.codice_cig && ` · CIG: ${r.codice_cig}`}
                </div>
              </div>
              <div className="flex items-center gap-3">
                <span className="text-xs font-medium px-2 py-0.5 rounded-full" style={{ color: cfg.color, backgroundColor: '#f3f4f6' }}>{cfg.label}</span>
                <button onClick={async () => { if (!confirm('Eliminare?')) return; await redApi.rendicontazioni.delete(r.id); toast.success('Eliminata'); load(); onUpdate() }} className="text-xs text-red-500 hover:text-red-700">🗑</button>
              </div>
            </div>
          )
        })}
        {rendicontazioni.length === 0 && <div className="text-center py-10 text-gray-400">Nessuna rendicontazione registrata.</div>}
      </div>
    </div>
  )
}

export default TabRendicontazioni
